// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11Hn_","content":"styles_content__2HIe_","tableWrap":"styles_tableWrap__3tcX9"};